import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { cosignDocumentsColumns } from "./co-sign.document.config";
import { ColDef } from "ag-grid-community";
import { ClientSideListBaseComponent } from "src/app/common/core/client-side-list-base/client-side-list-base.component";
import {
  ButtonComponent,
  ButtonVariant,
} from "src/app/common/components/core/button/button.component";
import { ListBaseComponent } from "src/app/common/core/list-base/list-base.component";
import { BehaviorSubject, debounceTime, Subject } from "rxjs";
import { AgGridModule } from "ag-grid-angular";
import { FormsModule } from "@angular/forms";
import { CosignSearchComponent } from "../cosign-search/cosign-search.component";
import { CoSignerClient } from "src/app/common/services/co-signer.client";
import { StorageService } from "src/app/common/services/storage.service";
import { CoSignDocumentDetails } from "src/app/common/interfaces/cosign-documents.interface";
import { CoSignRequest } from "src/app/common/interfaces/cosign-billing.interface";
import { Router } from "@angular/router";
import { SecurityFeatureUtility } from "src/app/common/services/security-feature.utility";
import { Features } from "src/app/common/enums/features.enum";
import { AppConstants } from "src/app/common/constants/app-constants";

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.scss"],
  standalone: true,
  imports: [
    ClientSideListBaseComponent,
    ButtonComponent,
    ListBaseComponent,
    AgGridModule,
    FormsModule,
    CosignSearchComponent,
  ],
})
export class DocumentsComponent implements OnInit {
  props: any;
  gridParams: any;
  searchText: any;
  buttonVariant = ButtonVariant;
  filteredRowData: CoSignDocumentDetails[] = [];
  selectedRowsToSign: any[] = [];
  rowSelection: "single" | "multiple" = "multiple";
  enableSign: boolean = false;
  currentUser: any;
  loggedInUser: any;
  currentFacility: any;
  canAccess: boolean = false;
  @ViewChild(ClientSideListBaseComponent)
  theraclient!: ClientSideListBaseComponent;
  private searchSubject: Subject<string> = new Subject<string>();
  columnDefs: any[] = [];

  rowData: CoSignDocumentDetails[] = [];

  selectedRows: [] = [];
  gridHeight: string = "auto";

  constructor(
    @Inject("userId") public userId: string,
    private cosignClient: CoSignerClient,
    private storageService: StorageService,
    private router: Router,
    private securityFeatureUtility: SecurityFeatureUtility
  ) {
    this.searchSubject.pipe(debounceTime(500)).subscribe((value: any) => {
      this.onSearch(value);
    });
  }
  ngOnInit(): void {
    this.canAccess =
      this.securityFeatureUtility.getSecurityFeature(Features.CO_SIGN, false)
        ?.featureaccess === AppConstants.manage;
    this.columnDefs = cosignDocumentsColumns(this).columnDefinitions;
    this.props = {
      currentPage$: new BehaviorSubject(1),
      totalPages: 0,
      sortDirection: "asc",
      columnDefs: cosignDocumentsColumns(this).columnDefinitions,
      filterableFields: cosignDocumentsColumns(this).columnDefinitions,
      rowHeight: 50,
    };
    this.currentUser = this.userId;
    this.loggedInUser = this.storageService.getUserId();
    this.currentFacility = this.storageService.getSelectedFacilityId();
    this.getCoSignDocuments();
    this.props.searchFunction = this.rowData;
  }

  getCoSignDocuments() {
    return this.cosignClient
      .getCoSignDocumentDetails(this.currentFacility, this.currentUser)
      .subscribe((data: any) => {
        this.rowData = data.responseData;
      });
  }

  typed(event: KeyboardEvent) {
    const value = this.searchText.trim();
    if (value.length == 0 || value.length > 2) {
      this.searchSubject.next(value);
    }
  }
  onRowChecked(event: any) {
    if (event.api.getSelectedRows().length > 0) {
      this.selectedRowsToSign = event.api
        .getSelectedRows()
        .map((x: any) => x.id);
      this.enableSign = event.api
        .getSelectedRows()
        .every((x: any) => x.issignenabled);
    } else {
      this.selectedRowsToSign = [];
      this.enableSign = false;
    }
  }

  onClickSign() {
    if (this.selectedRowsToSign.length > 0 && this.enableSign) {
      let cosignDocumentRequest: CoSignRequest = {
        cosignedby: this.loggedInUser,
        ids: this.selectedRowsToSign,
      };
      this.cosignClient
        .signDocumentDetails(cosignDocumentRequest)
        .subscribe((response: any) => {
          this.getCoSignDocuments();
        });
    }
  }

  onSearch({ keyword }: { keyword: string }) {
    if (keyword) {
      this.updateFilter(keyword);
    } else {
      this.filteredRowData = this.rowData;
      this.updateGridData();
    }
    this.props.currentPage$.next(1);
  }

  updateFilter(keyword: any) {
    const value = keyword.toString().toLowerCase().trim();
    if (!value) {
      this.filteredRowData = [...this.rowData];
      this.updateGridData();
      return;
    }
    const keys = this.columnDefs
      .filter((x) => x.sortable)
      .map((x) => x["field"]);
    this.filteredRowData = this.rowData.filter((item: any) => {
      return keys.some((key: any) => {
        return item[key] && item[key].toString().toLowerCase().includes(value);
      });
    });
    this.updateGridData();
  }

  private updateGridData() {
    this.props.totalPages = Math.ceil(
      this.filteredRowData.length / this.props.pageSize
    );
    this.theraclient.gridRowData = this.filteredRowData;
    this.theraclient.updateGridData();
  }

  navigateToDocumentsPage(params: any) {
    this.router.navigate(
      [
        "/patient",
        params.data.facilityid,
        "profile",
        params.data.patientid,
        "document",
      ],
      {
        queryParams: {
          documentid: params.data.documentid,
          disciplineid: params.data.disciplineid,
          frompage: "cosign",
        },
      }
    );
  }
}
